<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white" v-if="JSON.stringify(data) != '{}'">
				<div class="paper_edit_title flex">
					<div class="paper_edit_title_l">
						<p class="f20px">{{data.data.name}}</p>
						<div class="f16px cl_gray mat10">答题用时：{{data.use_time}}</div>
					</div>
					<div class="paper_edit_title_r tc cl_white cur" @click="submit">提交校对结果</div>
				</div>
				<div class="paper_edit mat30">
					<div class="paper_edit_l">
						<div class="paper_edit_nav f18px cl_dark">
							<div class="paper_edit_nav_list cur" :class="{'on': nav_cur == 1}" @click="navCheck(1)">试卷</div>
							<div class="paper_edit_nav_list cur" :class="{'on': nav_cur == 2}" @click="navCheck(2)">答案与解析</div>
						</div>
						<div class="paper_edit_cont mat20 bs" :style="{maxHeight:height}">
							<pdf v-for="i in numPages" :key="i" :src="src" :page="i" @page-loaded="pageLoaded($event)"></pdf>
						</div>
					</div>
					<div class="paper_edit_r" ref="paper_height">
						<div class="tc f16px">请对照左侧答案解析，对以下题目进行自主评分</div>
						<div class="paper_edit_card mat20">
							<div class="paper_card_list" v-for="(item,index) in data.data.card_json_arr" :key="index" v-if="['选择题','判断题'].indexOf(item.type) < 0">
								<div class="found_list_title flex f16px cl_violet radius8">
									<div class="found_list_title_l">{{item.number}}、{{item.type}}</div>
									<div>共{{item.topic.length}}题，{{item.fraction_all}}分</div>
								</div>
								<div class="found_list_cont mat20">
									<div class="found_list_item flex radius8" v-for="(second,secondIndex) in item.topic" :key="secondIndex">
										<div class="found_list_item_l flex">
											<div class="found_list_item_index">{{second.id}}</div>
											<div class="found_list_item_cont">
												<el-input-number v-model="second.mark" controls-position="right" :min="0" :max="second.fraction" :step="0.5"
												 size="small" class="found_dialog_item_num"></el-input-number>
												<span class="cl_gray mal15">满分：<span class="cl_red">{{second.fraction}}</span></span>
											</div>
										</div>
										<div class="found_list_item_r"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	import pdf from 'vue-pdf'
	
	export default {
		name: 'task_school_paper',
		components: {
			studentNav,
			pdf,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				id: "",
				data: {},
				nav_cur: 2,
				loading: true,
				src: '',
				numPages: undefined, // 总页数
				curPageNum: 0, //当前页
				height: "600px",
			}
		},
		created() {
			if (this.$route.query.data) {
				this.data = JSON.parse(this.$route.query.data);
				setTimeout(() => {
					this.getPdf();
				}, 0);
			}
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getPdf () {
				let that = this;
				that.src = pdf.createLoadingTask(that.data.data.answ_file); // url是pdf文件的全路径
				that.src.promise.then(pdf => {
						that.numPages = pdf.numPages;
				});
				setTimeout(() => {
					let height= that.$refs.paper_height.offsetHeight;
					if (height > 600) {
						that.height = height - 60 + "px"
					}
				}, 0);
			},
			navCheck (e) {
				let that = this;
				that.nav_cur = e;
				if (e == 1) {
					that.src = pdf.createLoadingTask(that.data.data.ques_file);
					that.src.promise.then(pdf => {
							that.numPages = pdf.numPages;
					});
				} else {
					that.src = pdf.createLoadingTask(that.data.data.answ_file);
					that.src.promise.then(pdf => {
							that.numPages = pdf.numPages;
					});
				}
				that.curPageNum = 0;
			},
			pageLoaded(e) {
				this.curPageNum = e;
				if (this.curPageNum == this.numPages) { //加载完最后一页
					this.loading = false;
				}
			},
			submit () {
				let card_json_arr = this.data.data.card_json_arr;
				let total_points = 0;
				for (let i = 0; i < card_json_arr.length; i++) {
					if (card_json_arr[i].type == "选择题") {
						for (let j = 0; j < card_json_arr[i].topic.length; j++) {
							let reply = [];
							let len = 0;
							for (let k = 0; k < card_json_arr[i].topic[j].arr.length; k++) {
								if (card_json_arr[i].topic[j].arr[k].on) {
									reply.push(card_json_arr[i].topic[j].arr[k].name);
								}
								if (card_json_arr[i].topic[j].arr[k].on == card_json_arr[i].topic[j].arr[k].check) {
									len ++
								}
								if (len == card_json_arr[i].topic[j].arr.length) {
									card_json_arr[i].topic[j].is_right = 1;
									card_json_arr[i].topic[j].mark = card_json_arr[i].topic[j].fraction;
								} else {
									card_json_arr[i].topic[j].is_right = 0;
									card_json_arr[i].topic[j].mark = 0;
								}
							}
							reply = reply.join(",");
							card_json_arr[i].topic[j].reply = reply;
							total_points += parseFloat(card_json_arr[i].topic[j].mark);
						}
					} else if (card_json_arr[i].type == "判断题") {
						for (let j = 0; j < card_json_arr[i].topic.length; j++) {
							for (let k = 0; k < card_json_arr[i].topic[j].arr.length; k++) {
								if (card_json_arr[i].topic[j].arr[k].on) {
									card_json_arr[i].topic[j].reply = card_json_arr[i].topic[j].arr[k].name;
								}
								if (card_json_arr[i].topic[j].arr[k].on == card_json_arr[i].topic[j].arr[k].check) {
									card_json_arr[i].topic[j].mark = card_json_arr[i].topic[j].fraction;
									card_json_arr[i].topic[j].is_right = 1;
								}
								if (card_json_arr[i].topic[j].arr[k].check) {
									card_json_arr[i].topic[j].answer = card_json_arr[i].topic[j].arr[k].name;
								}
							}
							total_points += parseFloat(card_json_arr[i].topic[j].mark);
						}
					} else {
						for (let j = 0; j < card_json_arr[i].topic.length; j++) {
							if (card_json_arr[i].topic[j].mark == card_json_arr[i].topic[j].fraction) {
								card_json_arr[i].topic[j].is_right = 1;
							} else {
								card_json_arr[i].topic[j].is_right = 0;
							}
							total_points += parseFloat(card_json_arr[i].topic[j].mark);
						}
					}
				}
				card_json_arr = JSON.stringify(card_json_arr)
				this.$get("/api/student/post_my_homework_submit",{
					token: localStorage.getItem("token"),
					card_json: card_json_arr,
					start_time: this.data.start_time,
					end_time: this.data.end_time,
					id: this.data.homework_dtl_find_data.id,
					total_points: total_points,
				})
				.then(res => {
					this.$message({
						duration: 2000,
						message: "提交成功",
						type: 'success'
					});
					setTimeout(() => {
						this.$router.push({path: '/task_school_report', query: {id: this.data.homework_dtl_find_data.id}});
					}, 2000);
				});
			},
		},
	}
</script>

<style>
</style>
